import { Text } from "@/components/ui/text";
import { Rank } from "@components/Rank";
import { Avatar } from "@features/Avatar";
import { Show } from "solid-js";
import { Box, Flex, Grid } from "styled-system/jsx";
import { timeAgo } from "./timeAgo";

export default function AuthorFooter(props: {
  username?: string | null;
  id?: string | null;
  rank?: string | null;
  date?: string | null;
}) {
  return (
    <Show when={props.username && props.id}>
      <Flex alignItems='center' gap='9px' minWidth={0}>
        <Box position='relative' flexShrink={0} w='30px' h='30px'>
          <Avatar id={props.id ?? undefined} />
          <Show when={props.rank}>
            <Box
              position='absolute'
              right='-3px'
              bottom='-3px'
              borderRadius='full'
              bg='editorialPanel'
              boxShadow='0 0 0 1px var(--colors-editorial-hair-strong)'
            >
              <Rank rank={props.rank ?? undefined} dimensions='14px' />
            </Box>
          </Show>
        </Box>
        <Grid gap='1px' minWidth={0}>
          <Text fontSize='12px' fontWeight='600' color='editorialInk' truncate textTransform='capitalize'>
            {props.username}
          </Text>
          <Text fontSize='11px' color='editorialInk3'>
            {timeAgo(props.date)}
          </Text>
        </Grid>
      </Flex>
    </Show>
  )
}
